<div class="editor-container">
  <section class="feature-page">
    <app-page-header
      [title]="isEditMode ? 'Editar Ministerio' : 'Nuevo Ministerio'"
      [subtitle]="isEditMode ? 'Modifica los datos del ministerio' : 'Crea un nuevo ministerio'">
    </app-page-header>
    
    <div class="feature-page__content form-wrapper">
      <form [formGroup]="form" (ngSubmit)="saveMinistry()" class="ministry-form">
        
        <mat-form-field class="full-width">
          <mat-label>Nombre</mat-label>
          <input matInput formControlName="name" placeholder="Ej: Apóstol">
          <mat-error *ngIf="form.get('name')?.hasError('required')">El nombre es requerido</mat-error>
          <mat-error *ngIf="form.get('name')?.hasError('minlength')">Mínimo 3 caracteres</mat-error>
          <mat-error *ngIf="form.get('name')?.hasError('maxlength')">Máximo 100 caracteres</mat-error>
        </mat-form-field>

        <div class="actions">
          <button mat-raised-button type="button" (click)="cancel()">Cancelar</button>
          <button mat-raised-button color="primary" type="submit" [disabled]="isSaving">
            <mat-icon *ngIf="!isSaving">save</mat-icon>
            <mat-progress-spinner *ngIf="isSaving" diameter="20"></mat-progress-spinner>
            {{ isSaving ? 'Guardando...' : 'Guardar' }}
          </button>
        </div>
      </form>
    </div>

  </section>
</div>
